var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DateTime } from 'luxon';
import api from '@utils/axios';
import { ALL_TIME_WORK_ORDER_DASHBOARD_PRESET_ID } from '../utils/workOrderDashboardDatePresets';
export const WORK_ORDERS_SUMMARY_PATH = '/api/internal/dashboard/work_orders_summary';
/**
 * Builds work-order date params for GET /api/internal/dashboard/work_orders_summary.
 */
export function buildWorkOrderDateParams(presetId, effectiveDateRange) {
    var _a, _b;
    if (presetId === ALL_TIME_WORK_ORDER_DASHBOARD_PRESET_ID)
        return { work_order_all_time: 'true' };
    if ((effectiveDateRange === null || effectiveDateRange === void 0 ? void 0 : effectiveDateRange.start) && (effectiveDateRange === null || effectiveDateRange === void 0 ? void 0 : effectiveDateRange.end)) {
        return {
            work_order_start_date: (_a = DateTime.fromJSDate(effectiveDateRange.start).toISODate()) !== null && _a !== void 0 ? _a : '',
            work_order_end_date: (_b = DateTime.fromJSDate(effectiveDateRange.end).toISODate()) !== null && _b !== void 0 ? _b : ''
        };
    }
    return {};
}
export function fetchWorkOrderSummary(_a) {
    return __awaiter(this, arguments, void 0, function* ({ territoryIds, presetId, dateRange }) {
        const params = {};
        if (territoryIds && territoryIds.length > 0) {
            params.territory_ids = territoryIds.map((t) => typeof t === 'object' && t !== null && 'value' in t ? t.value : t);
        }
        Object.assign(params, buildWorkOrderDateParams(presetId, dateRange));
        const response = yield api.get(WORK_ORDERS_SUMMARY_PATH, { params });
        return response.data;
    });
}
